import { Stack, Typography } from '@mui/material';

import CarIcon from '@/assets/icons/car.svg?react';
import { StatNumber } from '@/components/common/StatNumber';
import type { PickupParkingFacilityFeature } from '@/types/PickupParkingFacilityFeature';

interface DetailCardPickupParkingFacilityContentProps {
  facility: PickupParkingFacilityFeature;
}

export function PickupParkingFacilityDetailContent({ facility }: DetailCardPickupParkingFacilityContentProps) {
  return (
    <Stack gap={0.5} pl={2} py={1.5}>
      <Stack alignItems="center" direction="row" spacing={1}>
        <CarIcon />
        <StatNumber>{facility.properties.regularparkingspacenumber ?? '?'}</StatNumber>
      </Stack>

      <Stack alignItems="center" direction="row" pl={0.75} spacing={0.5}>
        <Typography
          title="Auto Stellplätze"
          sx={{
            display: 'inline',
            maxWidth: { xs: '100px', sm: '150px' },
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          Auto Stellplätze
        </Typography>
      </Stack>
    </Stack>
  );
}
